export const UPDATE_CACHED_IMG = 'UPDATE_CACHED_IMG';
